// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"6536e125b260b62a1d0abd573cdb8b40671f83e9aa760720ed91bceff743a916","build_node_testing_js":"816cc710321e62b731c75e4c130d4d09f3ccf5fbe23526cd28d1b8466c6cc485","node_modules_react_index_js":"511d55a02300b9454bcdc97dbe01f8b33dc52a8250efbdb5354b548694479f91"}[chunkId] + ".js";
};